import { ValidatorFn } from '@angular/forms/src/directives/validators';
import { Validation } from '../validation.interface';
import { Mask } from '../mask.interface';
import { FormControl } from '@angular/forms';

export class MeepCardPasswordModel implements Mask, Validation {

  static MEEP_CARD_PASSWORD = 'meepCardPasswordModel';
  static MEEP_CARD_PASSWORD_ERROR_DESCRIPTION = 'Formato de senha inválido';
  private MeepCardPasswordMask = [/[0-9]/, /\d/, /\d/, /\d/];

  static passwordMeepCard(password: FormControl) {
    if (password.value) {
      if (password.value.length !== 4) {
        return { [MeepCardPasswordModel.MEEP_CARD_PASSWORD]: true, description: 'Invalid size' };
      }
      return null;
    } else {
      return { [MeepCardPasswordModel.MEEP_CARD_PASSWORD]: true, description: 'Invalid field' };
    }
  }

  getMaskRule(): (string | RegExp)[] | Function | boolean {
    return this.MeepCardPasswordMask;
  }
  getValidatorsName(): string {
    return MeepCardPasswordModel.MEEP_CARD_PASSWORD;
  }
  getValidatorsErrorDescription(): string {
    return MeepCardPasswordModel.MEEP_CARD_PASSWORD_ERROR_DESCRIPTION;
  }
  getValidatorsRule(): ValidatorFn {
    return MeepCardPasswordModel.passwordMeepCard;
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/components/input/rules/implementations/meepCardPassword.model.ts